<template>
<div id="kasko">
    <sravni-widget  type='kasko' theme='sravni_blue' width='1000' partner='v-avtoservis-r-f' inIframe='false' hide-partners='true'></sravni-widget>
</div>
</template>

<script>
export default {
  name: 'kasko'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/blocks/kasko.vue